<!--
2026-05-07 YTW 预测竞猜-MVP
-->
<template>
  <div class="main-content" id="main-content">
    <div class="phone">
      <div class="hdr">
        <TopBack style="position: relative" :title="$t('lang.predict.title')"/>
        <button class="hdr-btn" @click="goto('PredictRecord')">{{ $t('lang.predict.mybets') }}</button>
      </div>
      <div class="scr"
           ref="scr"
           @touchstart="touchStart"
           @touchmove="touchMove"
           @touchend="touchEnd">
        <div class="scr-inner" :style="{transform: `translate3d(0, ${pullY}px, 0)`}">
          <div class="sec-lbl">Open for betting</div>
          <div class="part" v-if="ActiveList && ActiveList.length">
            <div class="card" v-for="(card, index) in ActiveList" :key="index">
              <div class="card-top">
                <div class="card-q" v-if="$store.state.locale === 'EN'"><span
                  v-if="card.QuestionCategory === 'Match'">⚽&nbsp;</span><span v-else>🎯&nbsp;</span>{{
                    card.ContentEnglish
                  }}<br><span
                    class="card-sub" v-if=" card.SubtitleEnglish">{{ card.SubtitleEnglish }}</span></div>
                <div class="card-q" v-else><span
                  v-if="card.QuestionCategory === 'Match'">⚽&nbsp;</span><span v-else>🎯&nbsp;</span>{{ card.ContentHindi }}<br><span
                  class="card-sub" v-if=" card.SubtitleHindi">{{
                    card.SubtitleHindi
                  }}</span></div>
                <div class="live-badge">
                  <div class="live-dot"></div>
                  <span class="live-txt">{{ card.EndTimeDisplay }}</span></div>
              </div>
              <div class="card-meta"><span class="card-date">{{ card.DateDisplay }}</span><span
                class="dot">·</span><span
                class="card-src">{{ card.ResultSource }}</span></div>
              <div class="opt-row">
                <div class="opt-btn" @click="chooseCard(card, 1)" :class="{'yes-sel': card.Choose === 1}"><span
                  class="opt-lbl">YES</span><span
                  class="opt-odds">×{{ card.Odds }}</span></div>
                <div class="opt-btn" @click="chooseCard(card, 2)" :class="{'no-sel': card.Choose === 2}"><span
                  class="opt-lbl">NO</span><span class="opt-odds">×{{ card.Odds }}</span></div>
              </div>
              <div class="share-ic pge" @click="doShareCard(card)">
                <img src="../../assets/images/Predict/predictShare.svg" alt="">
              </div>
              <div class="quick-row" v-if="card.Choose&&(card.Choose === 1||card.Choose === 2)">
                <div class="q-btn" @click="quickCard($event,card, item)" :class="card.Amount === item.sel?'sel':''"
                     v-for="(item, index) in selList"
                     :key="index">
                  ₹{{ item.sel }}
                </div>
              </div>
              <div class="amt-row" v-if="card.Choose&&(card.Choose === 1||card.Choose === 2)">
                <input
                  :class="{'err': card.Error>0}"
                  class="amt-input"
                  :value="'₹ ' + card.Amount"
                  type="text"
                  inputmode="numeric"
                  @input="onAmountInput($event, card)"
                  @blur="handleAmountBlur(card.QuestionId)"
                  @keydown="onKeyDown($event, card.QuestionId)"
                />
                <div class="bet-btn" @click="doBet(card)">{{
                    $t('lang.predict.bet')
                  }}
                </div>
              </div>
              <div class="err-msg" v-if="card.ErrorMessage"><span class="err-ic">!</span> {{ card.ErrorMessage }}</div>
              <div class="hint-row" v-if="card.Choose&&(card.Choose === 1||card.Choose === 2)&&!card.ErrorMessage"><span
                class="hint-normal">{{ $t('lang.predict.normalMsg') }}</span></div>
            </div>
            <div class="divider" v-if="(ClosedList && ClosedList.length) ||(SettledList && SettledList.length)"></div>
          </div>
          <div class="part" v-if="ClosedList && ClosedList.length">
            <div class="card" style="margin-top: 2.777vw;" v-for="(card, index) in ClosedList" :key="index">
              <div class="card-top">
                <div class="card-q" v-if="$store.state.locale === 'EN'"><span
                  v-if="card.QuestionCategory === 'Match'">⚽&nbsp;</span><span v-else>🎯&nbsp;</span>{{
                    card.ContentEnglish
                  }}<br><span
                    class="card-sub" v-if=" card.SubtitleEnglish">{{ card.SubtitleEnglish }}</span></div>
                <div class="card-q" v-else><span
                  v-if="card.QuestionCategory === 'Match'">⚽&nbsp;</span><span v-else>🎯&nbsp;</span>{{ card.ContentHindi }}<br><span
                  class="card-sub" v-if=" card.SubtitleHindi">{{
                    card.SubtitleHindi
                  }}</span></div>
                <div class="closed-badge">{{ $t('lang.predict.closed') }}</div>
              </div>
              <div class="card-meta"><span class="card-date">{{ card.DateDisplay }}</span><span
                class="dot">·</span><span
                class="card-src">{{ card.ResultSource }}</span></div>
              <div class="opt-row">
                <div class="opt-dis"><span class="opt-lbl">YES</span><span class="opt-odds">×{{ card.Odds }}</span>
                </div>
                <div class="opt-dis"><span class="opt-lbl">NO</span><span class="opt-odds">×{{ card.Odds }}</span></div>
              </div>
              <div class="res-row"><span class="res-lbl">{{ $t('lang.predict.result') }}</span>
                <span class="res-pending">{{ $t('lang.predict.pending') }}</span>
              </div>
            </div>
            <div class="divider" v-if="SettledList && SettledList.length"></div>
          </div>
          <div class="card" v-if="expandSettled" style="margin-top: 2.777vw;" v-for="(card, index) in SettledList"
               :key="index">
            <div class="card-top">
              <div class="card-q" v-if="$store.state.locale === 'EN'"><span
                v-if="card.QuestionCategory === 'Match'">⚽&nbsp;</span><span v-else>🎯&nbsp;</span>{{ card.ContentEnglish }} <span
                v-if="card.SubtitleEnglish">·</span> {{ card.SubtitleEnglish }}
              </div>
              <div class="card-q" v-else><span
                v-if="card.QuestionCategory === 'Match'">⚽&nbsp;</span><span v-else>🎯&nbsp;</span>{{ card.ContentHindi }} <span
                v-if="card.SubtitleHindi">·</span> {{ card.SubtitleHindi }}
              </div>
            </div>
            <div class="card-meta"><span class="card-date">{{ card.DateDisplay }}</span><span class="dot">·</span><span
              class="card-src">{{ card.ResultSource }}</span></div>
            <div class="res-row"><span class="res-lbl">{{ $t('lang.predict.result') }}</span>
              <span class="res-yes" v-if="card.Result === 'Yes'">YES ✓</span>
              <span class="res-no" v-if="card.Result === 'No'">NO ✗</span>
              <span class="res-ref" v-if="card.Result === 'Refund'">Refund</span>
            </div>
          </div>
          <div class="show-more" style="margin-top:2.777vw;" v-if="!expandSettled&&SettledList && SettledList.length"
               @click="expandSettled=true"><span>{{ $t('lang.predict.showResults') }}</span>
          </div>
          <div class="show-more" style="margin-top:2.777vw;" v-if="expandSettled&&SettledList && SettledList.length"
               @click="expandSettled=false"><span>{{ $t('lang.predict.hideResults') }}</span>
          </div>
          <div style="text-align:center;padding:  3.888vw 01.11vw;" @click="openPanel()">
            <span style="font-size: 3.333vw;color:rgba(255,255,255,0.2);">{{ $t('lang.predict.rules') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="panel" v-show="modalShow">
      <div class="sheet-wrap">
        <div class="sheet-won" @click="closePanel()"/>
        <div class="sheet-overlay">
          <div style="height:13.888vw;display:flex;align-items:center;justify-content:center;" @click="closePanel()">
            <span style="color:rgba(255,255,255,0.15);font-size:3.333vw;">page content behind overlay</span>
          </div>
          <div class="sheet">
            <div class="sh-handle"></div>
            <div class="sh-title">{{ $t('lang.predict.how') }}</div>
            <div class="sh-body">
              <div class="sh-area" v-html="$t('lang.predict.area1')"/>
              <div class="sh-area" v-html="$t('lang.predict.area2')"/>
              <div v-html="$t('lang.predict.area3')"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="share-overlay" v-if="shareOverlayShow">
      <div class="share-sheet">
        <div class="share-text">{{ shareCode.substring(0, 25) + '...' }}<span class="copy" @click="copyLinkClick()">{{
            $t('lang.invitee.copy')
          }}</span></div>
        <div class="share-channels">
          <div class="ch-btn" @click="whatsappClick()">
            <div class="ch-icon ch-wa">
              <img class="ch-in" src="../../assets/images/Predict/whatsapp.webp" alt="whatsapp">
            </div>
            <span class="ch-lbl">WhatsApp</span>
          </div>
          <div class="ch-btn" @click="instagramClick()">
            <div class="ch-icon">
              <img class="ch-in" src="../../assets/images/Predict/instagram.webp" alt="instagram">
            </div>
            <span class="ch-lbl">Instagram</span>
          </div>
          <div class="ch-btn" @click="facebookClick()">
            <div class="ch-icon ch-fb">
              <img class="ch-in" src="../../assets/images/Predict/facebook.webp" alt="facebook">
            </div>
            <span class="ch-lbl">Facebook</span>
          </div>
          <div class="ch-btn"  @click="telegramClick()">
            <div class="ch-icon ch-tg">
              <img class="ch-in" src="../../assets/images/Predict/telegram.webp" alt="telegram">
            </div>
            <span class="ch-lbl">Telegram</span>
          </div>
        </div>
        <div class="cancel" @click="shareOverlayShow=false"><img src="../../assets/images/Predict/close.svg"
                                                                 alt="close"/></div>
      </div>
    </div>
  </div>
</template>
<script>
import TopBack from '@/components/PredictTopBack/index'
import request from '@/service'
import {Toast} from 'mint-ui'

export default {
  name: 'Predict',
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      shareCode: null,
      modalShow: false,
      shareOverlayShow: false,
      pullY: 0,
      startY: 0,
      canPull: false,
      updateTime: null,
      expandSettled: false,
      selList: [{sel: 10}, {sel: 50}, {sel: 100}],
      shareCard: {},
      ActiveList: [],
      ClosedList: [],
      SettledList: []
    }
  },
  components: {
    TopBack
  },
  watch: {
    ActiveList: function (n) {
      this.updateTime = new Date()
    },
    '$store.state.locale': function (n, o) {
      this.ActiveList.forEach((item) => {
        if (item.Error === 2) {
          item.ErrorMessage = this.$t('lang.predict.errorMsg2').replace('{amount}', this.$store.state.predictMaxBetAmount)
        } else if (item.Error === 4) {
          item.ErrorMessage = this.$t('lang.predict.errorMsg2').replace('{amount}', item.Amt)
        } else if (item.Error > 0) {
          item.ErrorMessage = this.$t('lang.predict.errorMsg' + item.Error)
        } else {
          item.ErrorMessage = ''
        }
      })
    }
  },
  created () {
  },
  mounted () {
    if (!this.userInfo) {
      this.goto('Login')
      return
    }
    this.fetchAccount()
    this.getData()
  },
  methods: {
    fetchAccount () {
      const url = '/innovation/account/getuseraccount'
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data).then(res => {
        this.shareCode = res.InviteLink
      }).catch(err => {
        console.log(err)
      })
    },
    onAmountInput (e, card) {
      if (card.Error === 1) {
        card.Error = 0
        card.ErrorMessage = ''
      }
      let val = e.target.value
      // 保留数字和₹
      val = val.replace(/[^\d₹]/g, '')
      // 防止多个₹
      val = '₹ ' + val.replace(/₹/g, '')
      // 提取数字判断最大值
      let num = parseInt(val.replace(/\D/g, ''), 10)
      if (num > 9999999) {
        num = 9999999
      }
      val = '₹ ' + (num || '')
      // 更新输入框
      e.target.value = val
      card.Amount = num || ''
    },
    doShareCard (card) {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.shareCard = card
      this.shareOverlayShow = true
    },
    quickCard (e, card, item) {
      if (card.Error === 1) {
        card.Error = 0
        card.ErrorMessage = ''
      }
      e.target.value = item.sel
      card.Amount = item.sel || ''
    },
    handleAmountBlur (id) {
      let card = this.ActiveList.find(
        c => c.QuestionId === id
      )

      let val = parseInt(card.Amount, 10)

      if (isNaN(val)) {
        card.Amount = ''
        return
      }
      card.Amount = String(Math.floor(val))
    },
    onKeyDown (e, id) {
      let card = this.ActiveList.find(
        c => c.QuestionId === id
      )

      if (
        (e.key === 'Backspace' || e.key === 'Delete') &&
        !card.Amount
      ) {
        e.preventDefault()
      }
    },
    chooseCard (card, val) {
      card.Choose = val
      if (card.Error === 1) {
        card.Error = 0
        card.ErrorMessage = ''
      }
    },
    getData () {
      const url = '/innovation/predict/questions'
      const params = {}
      request('post', url, params).then(res => {
        if (res.Code === 1) {
          res.ActiveList.forEach((card) => {
            card.Amount = 10
            card.Choose = 0
            card.Error = 0
            card.ErrorMessage = ''
          })
          this.ActiveList = res.ActiveList
          this.ClosedList = res.ClosedList
          this.SettledList = res.SettledList
        }
      }).catch(err => {
        console.log(err)
      })
    },
    goBack () {
      this.$router.go(-1)
    },
    goto (path) {
      this.$router.push('/' + path)
    },
    openPanel () {
      this.modalShow = true
    },
    closePanel () {
      this.modalShow = false
    },
    touchStart (e) {
      const el = this.$refs.scr
      // 必须在顶部
      this.canPull = el.scrollTop <= 0
      if (this.canPull) {
        this.startY = e.touches[0].clientY
      }
    },
    touchMove (e) {
      if (!this.canPull) return
      const currentY = e.touches[0].clientY
      let distance = currentY - this.startY
      // 只允许下拉
      if (distance <= 0) return
      // 阻尼
      distance *= 0.35
      // 最大距离
      if (distance > 120) {
        distance = 120
      }
      this.pullY = distance
    },
    touchEnd () {
      if (this.pullY > 80) {
        this.getData()
      }
      this.canPull = false
      this.pullY = 0
    },
    doBet (card) {
      if (!card.Choose || (card.Choose !== 1 && card.Choose !== 2)) {
        card.Error = 1
        card.ErrorMessage = this.$t('lang.predict.errorMsg1')
      } else if (card.Amount <= 0) {
        card.Error = 5
        card.ErrorMessage = this.$t('lang.predict.errorMsg5')
      } else if (card.Amount > this.$store.state.predictMaxBetAmount) {
        card.Error = 2
        card.ErrorMessage = this.$t('lang.predict.errorMsg2').replace('{amount}', this.$store.state.predictMaxBetAmount)
      } else {
        const url = '/innovation/predict/placeBet'
        const params = {
          UserId: this.userInfo.UserId,
          QuestionId: card.QuestionId,
          BetSide: card.Choose === 1 ? 'Yes' : 'No',
          Amount: card.Amount
        }
        request('post', url, params).then(res => {
          if (res.Code === 1) {
            card.Choose = 0
            card.Amount = 10
            card.Error = 0
            card.ErrorMessage = ''
            Toast(this.$t('lang.common.success'))
          } else {
            if (res.Code === -6 && res.Message.indexOf('Max bet per side') > -1) {
              card.Error = 2
              card.ErrorMessage = this.$t('lang.predict.errorMsg2').replace('{amount}', this.$store.state.predictMaxBetAmount)
            } else if (res.Code === -6 && res.Message.indexOf('Per-side') > -1) {
              card.Error = 4
              const amt = res.Message.split('₹')
              card.Amt = amt[1]
              card.ErrorMessage = this.$t('lang.predict.errorMsg4').replace('{amount}', amt[1])
            } else if (res.Code === -8) {
              card.Error = 3
              card.ErrorMessage = this.$t('lang.predict.errorMsg3')
            } else {
              Toast(res.Message)
            }
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    saveUserEvent (val) {
      const url = '/innovation/account/save/user/event'
      const data = {EventNameEN: val, UserUniqueId: this.userInfo ? this.userInfo.UserId : ''}
      request('post', url, data).then(res => {
      }).catch(err => {
        console.log(err)
      })
    },
    telegramClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('Telegram')
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat())
      window.open(`https://t.me/share/url?text=` + message + `&url=%20`)
    },
    whatsappClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('WhatsApp')
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat())
      window.open(`https://wa.me/?text=${message}`, '_blank')
    },
    facebookClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('Facebook')
      this.copyShares()
      window.open(`https://www.facebook.com/sharer.php?u=` + this.shareCode, '_blank')
    },
    async instagramClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('Instagram')
      const shareData = {
        text: this.msgFormat()
      }

      if (navigator.share) {
        try {
          await navigator.share(shareData)
        } catch (e) {
        }
      } else {
        this.copyShares()
      }
    },
    msgFormat () {
      let welcomeMessage = this.$t('lang.sportsBetting.shareMsg')
      let index = this.shareCode.indexOf('/Share')
      if (index === -1) {
        index = this.shareCode.toLowerCase().indexOf('/share')
      }

      welcomeMessage = welcomeMessage.replace('{shareUrl}', this.shareCode)
      return welcomeMessage
    },
    copyShares () {
      let message = this.msgFormat()
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', message)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
    },
    copyLinkClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.copyShares()
      this.saveUserEvent('Link2')
      Toast(this.$t('lang.inviteFriends.success'))
    }
  }
}
</script>

<style lang="less" scoped>
.main-content {
  position: fixed;
  padding: 56px 0 0 0;
  width: 100vw;
  height: 100dvh;
  background-color: #000000;
  display: flex;
  overflow: hidden;

  .relative {
    position: absolute;
    width: 100vw;
    height: max-content;
    z-index: 0;
  }

  .rules {
    position: relative;
    top: 21.6667vw;
    left: 50%;
    transform: translate(-50%);
    width: 90.555vw;
    height: max-content;
    padding-bottom: 10vw;

    .title {
      font-family: Inter;
      font-size: 6.111vw;
      font-weight: 700;
      line-height: 6.388vw;
      text-align: left;
      color: #FFFFFF;
      margin-bottom: 2vw;
    }

    .content {
      padding: 2vw 0 0 1.111vw;
      font-family: Inter;
      font-size: 4.166vw;
      font-weight: 500;
      line-height: 5.556vw;
      text-align: left;
      color: #FFFFFF;
      height: max-content;

      p {
        margin-bottom: 1vw;
      }
    }
  }

  .panel {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100dvh;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.66);

    .modal {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 83.333vw;
      height: 55.556vw;
      background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
      border: 0.277vw solid #737373;
      border-radius: 4.166vw;

      .top {
        margin-top: 4vw;
        text-align: center;
        font-size: 5.556vw;
        font-weight: 700;
        color: #FFFFFF;
      }

      .message {
        position: relative;
        top: 3vw;
        left: 50%;
        transform: translate(-50%);
        width: 68.672vw;
        height: max-content;
        color: #C4C4C4;
        font-size: 3.888vw;
        font-weight: 400;
        line-height: 5.556vw;
        letter-spacing: 0.02em;
      }

      .buttons {
        position: relative;
        top: 8vw;
        left: 50%;
        transform: translate(-50%);
        display: flex;
        width: 69.444vw;
        height: 8.333vw;
        justify-content: space-between;

        .btn {
          width: 32.222vw;
          height: 8.333vw;
          line-height: 8.333vw;
          text-align: center;
          background: linear-gradient(270.12deg, #DEBC86 -2.41%, #F7DEB8 113.36%);
          font-family: Inter;
          font-size: 3.889vw;
          font-weight: 500;
          color: #000000;
          border-radius: 0.833vw;
        }

        .ok {
          margin-top: 3.8vw;
          width: 100%;
          text-align: center;
        }
      }
    }
  }

  /* ── SHARE PANEL ── */

  .share-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100dvh;
    z-index: 10;
    background: rgba(0, 0, 0, 0.72);
  }

  .share-sheet {
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 85vw;
    height: 43.0555vw;
    background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #1F1F1F 0%, #1B1B1B 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
    border-radius: 2.2vw;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    .share-text {
      position: relative;
      margin: 0 auto;
      width: 76.944vw;
      height: 9.166vw;
      border: 0.3vw solid #737373;
      border-radius: 2.22vw;
      white-space: nowrap;
      line-height: 9.166vw;
      font-family: 'Inter';
      padding-left: 3.75vw;
      font-style: normal;
      font-weight: 400;
      font-size: 3.888vw;
      color: #FFFFFF;

      .copy {
        position: absolute;
        right: 3.75vw;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 3.888vw;
        text-decoration-line: underline;
        color: var(--primary-color);
      }
    }

    .share-channels {
      display: flex;
      justify-content: space-around;
      padding: 0 5.556vw;
    }

    .cancel {
      position: absolute;
      width: 3.333vw;
      height: 3.333vw;
      bottom: -7vw;
      left: 50%;
      transform: translate(-50%);
      img{
        width: 100%;
        height: 100%;
      }
    }
  }

  .ch-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2vw;
    cursor: pointer;
  }

  .ch-icon {
    width: 12.5vw;
    height: 12.5vw;
    border-radius: 3.888vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ch-tg {
    background: #229ED9;
  }

  .ch-wa {
    background: #25D366;
  }

  .ch-fb {
    background: #1877F2;
  }

  .ch-cp {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.12);
  }

  .ch-in {
    width: 12.5vw;
    height: 12.5vw
  }

  .ch-lbl {
    font-size: 3.888vw;
    color: #FFFFFF;
    font-weight: 400;
  }
}

.main-content::-webkit-scrollbar {
  display: none
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background: #1c1c1e;
  font-family: -apple-system, 'Helvetica Neue', sans-serif;
  color: #fff;
  padding: 11.11vw 6.67vw;
}

h1 {
  font-size: 6.11vw;
  font-weight: 700;
  color: var(--primary-color);
  margin-bottom: 1.11vw;
}

.subtitle {
  font-size: 3.61vw;
  color: rgba(255, 255, 255, 0.4);
  margin-bottom: 11.11vw;
}

.spec-section-title {
  font-size: 3.06vw;
  font-weight: 700;
  letter-spacing: 0.001em;
  text-transform: uppercase;
  color: rgba(246, 217, 170, 0.5);
  margin-bottom: 5.56vw;
  padding-bottom: 2.22vw;
  border-bottom: 0.28vw solid rgba(255, 255, 255, 0.06);
}

/* ── TYPE TABLE ── */
table {
  width: 100%;
  border-collapse: collapse;
}

th {
  font-size: 3.06vw;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.35);
  text-align: left;
  padding: 1.67vw 3.33vw;
  letter-spacing: 0.14vw;
}

td {
  font-size: 3.61vw;
  color: rgba(255, 255, 255, 0.8);
  padding: 2.22vw 3.33vw;
  border-top: 0.28vw solid rgba(255, 255, 255, 0.05);
  vertical-align: middle;
}

td:first-child {
  color: rgba(255, 255, 255, 0.45);
  font-size: 3.33vw;
}

.preview {
  display: inline-block;
}

/* ── COMPONENT SPECS ── */
.comp-row {
  display: flex;
  gap: 8.89vw;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-bottom: 8.89vw;
}

.comp-box {
  flex-shrink: 0;
}

.comp-label {
  font-size: 3.06vw;
  color: rgba(255, 255, 255, 0.3);
  margin-bottom: 2.78vw;
  letter-spacing: 0.14vw;
}

.anno-box {
  flex: 1;
  min-width: 72.22vw;
}

.anno-title {
  font-size: 3.33vw;
  font-weight: 600;
  color: rgba(246, 217, 170, 0.7);
  margin-bottom: 2.78vw;
}

.anno-row {
  display: flex;
  justify-content: space-between;
  padding: 1.39vw 0;
  border-bottom: 0.28vw solid rgba(255, 255, 255, 0.04);
}

.anno-key {
  font-size: 3.33vw;
  color: rgba(255, 255, 255, 0.4);
}

.anno-val {
  font-size: 3.33vw;
  color: #fff;
  font-family: 'SF Mono', monospace;
  text-align: right;
}

.phone {
  position: relative;
  width: 100vw;
  height: calc(100dvh - 56px);
  background: #090909;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.phone-inner {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ── REDLINE OVERLAY HELPERS ── */
.rl {
  position: relative;
}

.rl::after {
  content: attr(data-anno);
  position: absolute;
  right: -36.11vw;
  top: 50%;
  transform: translateY(-50%);
  font-size: 2.777vw;
  color: #ff6b6b;
  white-space: nowrap;
  font-family: 'SF Mono', monospace;
  pointer-events: none;
}

.rl-t::after {
  top: -5vw;
  right: auto;
  left: 0;
  transform: none;
}

.rl-b::after {
  top: auto;
  bottom: -5vw;
  right: auto;
  left: 0;
  transform: none;
}

.hdr {
  padding: 0 5.555vw 2.22vw 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.hdr-title {
  color: var(--primary-color);
  font-size: 5.56vw;
  font-weight: 700;
}

.hdr-btn {
  color: var(--primary-color);
  font-size: 3.61vw;
  border: 0.28vw solid rgba(246, 217, 170, 0.3);
  border-radius: 5.555vw;
  padding: 1.39vw 3.33vw;
  margin-top: 2.5vw;
  background: transparent;
}

.scr {
  position: relative;
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 1.11vw 4.44vw 4.44vw;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}

.scr-inner {
  min-height: 100%;
  transition: transform .2s;
  will-change: transform;
}

.scr::-webkit-scrollbar {
  display: none;
}

.sec-lbl {
  font-size: 3.06vw;
  font-weight: 600;
  letter-spacing: 0.0005em;
  color: rgba(246, 217, 170, 0.5);
  text-transform: uppercase;
  padding: 3.33vw 0 2.22vw;
}

/* ── CARD ── */
.card {
  position: relative;
  background: #1a1a1a;
  border-radius: 4.44vw;
  margin-bottom: 2.777vw;
  padding: 3.89vw 4.44vw 10.555vw 4.44vw;
  border: 0.3vw solid rgba(255, 255, 255, 0.06);
}

.show-more {
  text-align: center;
  padding: 2.777vw 0 1.111vw;
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.67vw;
}

.card-q {
  color: #fff;
  font-size: 4.166vw;
  font-weight: 600;
  line-height: 1.35;
  flex: 1;
  padding-right: 2.22vw;
}

.card-sub {
  color: rgba(255, 255, 255, 0.4);
  font-size: 3.61vw;
  font-weight: 400;
}

.card-meta {
  display: flex;
  align-items: center;
  gap: 1.67vw;
  margin-bottom: 2.777vw;
}

.card-date {
  color: rgba(255, 255, 255, 0.4);
  font-size: 3.333vw;
}

.card-src {
  color: rgba(255, 255, 255, 0.3);
  font-size: 3.06vw;
}

.dot {
  color: rgba(255, 255, 255, 0.2);
  font-size: 2.777vw;
}

.live-badge {
  display: flex;
  align-items: center;
  gap: 1.11vw;
  background: rgba(246, 217, 170, 0.1);
  border-radius: 5.555vw;
  padding: 0.83vw 2.22vw;
  width: 14.722vw;
  flex-shrink: 0;
  justify-content: center;
}

.live-dot {
  width: 1.67vw;
  height: 1.67vw;
  border-radius: 50%;
  background: var(--primary-color);
  animation: pulse 1.8s ease-in-out infinite;
}

.live-txt {
  color: var(--primary-color);
  font-size: 2.777vw;
  font-weight: 600;
  letter-spacing: 0.08vw;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.35;
    transform: scale(1.35);
  }
}

.share-ic {
  position: absolute;
  bottom: 3vw;
  right: 3.333vw;
  width: 5.555vw;
  height: 5.555vw;
  opacity: 0.45;
}

.share-ic.pge {
  color: var(--primary-color);
}

.share-ic.ba-c {
  color: #fbd500;
}

.opt-row {
  display: flex;
  gap: 2.22vw;
}

.opt-btn {
  flex: 1;
  padding: 2.777vw 2.22vw;
  border-radius: 2.777vw;
  border: 0.42vw solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6vw;
}

.opt-btn.yes-sel {
  border-color: #4caf82;
  background: rgba(76, 175, 130, 0.12);
}

.opt-btn.no-sel {
  border-color: #0073d7;
  background: rgba(0, 115, 215, 0.1);
}

.opt-lbl {
  font-size: 3.888vw;
  font-weight: 700;
  color: #fff;
}

.opt-odds {
  font-size: 3.06vw;
  color: rgba(255, 255, 255, 0.45);
}

.opt-btn.yes-sel .opt-lbl {
  color: #4caf82;
}

.opt-btn.yes-sel .opt-odds {
  color: rgba(76, 175, 130, 0.7);
}

.opt-btn.no-sel .opt-lbl {
  color: #0073d7;
}

.opt-btn.no-sel .opt-odds {
  color: rgba(0, 115, 215, 0.7);
}

.amt-row {
  display: flex;
  gap: 2.22vw;
  margin-top: 2.78vw;
  align-items: center;
}

.hint-row {
  display: flex;
  align-items: center;
  gap: 1.11vw;
  margin-top: 1.388vw;
  min-height: 4.444vw;
}

.hint-normal {
  font-size: 3.055vw;
  color: rgba(255, 255, 255, 0.25);
}

.quick-row {
  display: flex;
  gap: 1.666vw;
  margin-top: 2.777vw;

  .q-btn {
    flex: 1;
    padding: 2vw 1.111vw;
    border-radius: 2.22vw;
    border: 1.5px solid rgba(255, 255, 255, 0.15);
    background: transparent;
    font-size: 3.06vw;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.5);
    text-align: center;
  }

  .q-btn.sel {
    background: var(--primary-color);
    border-color: var(--primary-color);
    color: #090909;
  }

  .q-btn.sel.ba {
    background: #fbd500;
    border-color: #fbd500;
    color: #000;
  }
}

.amt-input {
  flex: 1;
  background: rgba(255, 255, 255, 0.07);
  border: 0.28vw solid rgba(255, 255, 255, 0.1);
  border-radius: 2.22vw;
  padding: 2.50vw 3.33vw;
  color: #fff;
  font-size: 4.166vw;
  font-weight: 600;
  outline: none;
  text-align: center;
}

.amt-input.err {
  border-color: #e05c5c;
  background: rgba(224, 92, 92, 0.07);
}

.bet-btn {
  background: var(--primary-color);
  color: #090909;
  font-size: 3.888vw;
  font-weight: 700;
  border: none;
  border-radius: 2.22vw;
  flex-shrink: 0;
  width: 17.777vw;
  height: 10.186vw;
  line-height: 10.186vw;
  white-space: nowrap;
  text-align: center;
}

.bet-btn:active {
  transform: scale(0.92);
  opacity: 0.85;
}

.bet-btn.dis {
  background: rgba(246, 217, 170, 0.25);
  color: rgba(9, 9, 9, 0.4);
}

.err-msg {
  color: #e05c5c;
  font-size: 3.333vw;
  margin-top: 1.67vw;
  display: flex;
  align-items: center;
  gap: 1.11vw;
}

.err-ic {
  width: 3.89vw;
  height: 3.89vw;
  border-radius: 50%;
  background: #e05c5c;
  color: #fff;
  font-size: 2.50vw;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.closed-badge {
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.4);
  font-size: 2.777vw;
  font-weight: 600;
  letter-spacing: 0.0005em;
  text-transform: uppercase;
  border-radius: 5.555vw;
  padding: 0.83vw 2.22vw;
  width: 16.111vw;
  text-align: center;
}

.opt-dis {
  flex: 1;
  padding: 2.777vw 2.22vw;
  border-radius: 2.777vw;
  border: 0.42vw solid rgba(255, 255, 255, 0.06);
  background: rgba(255, 255, 255, 0.02);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6vw;
}

.opt-dis .opt-lbl {
  color: rgba(255, 255, 255, 0.2);
  font-size: 3.888vw;
  font-weight: 700;
}

.opt-dis .opt-odds {
  color: rgba(255, 255, 255, 0.15);
  font-size: 3.06vw;
}

.res-row {
  margin-top: 2.22vw;
  display: flex;
  align-items: center;
  gap: 1.67vw;
}

.res-lbl {
  font-size: 3.333vw;
  color: rgba(255, 255, 255, 0.4);
}

.res-pending {
  font-size: 3.333vw;
  color: rgba(246, 217, 170, 0.6);
  font-weight: 500;
  text-transform: capitalize;
}

.res-yes {
  font-size: 3.61vw;
  color: #4caf82;
  font-weight: 700;
}

.res-no {
  font-size: 3.61vw;
  color: #e05c5c;
  font-weight: 700;
}

.res-ref {
  font-size: 3.61vw;
  color: #ffffff;
  font-weight: 700;
}

.divider {
  height: 0.28vw;
  background: rgba(255, 255, 255, 0.05);
  margin: 1.11vw 0 0;
}

/* MY BETS */
.bet-card {
  background: #1a1a1a;
  border-radius: 3.89vw;
  margin-bottom: 2.22vw;
  padding: 3.61vw 3.89vw;
  border: 0.3vw solid rgba(255, 255, 255, 0.06);
}

.bet-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.11vw;
}

.bet-q {
  color: #fff;
  font-size: 3.888vw;
  font-weight: 600;
  line-height: 1.3;
  flex: 1;
  padding-right: 2.22vw;
}

.bet-date {
  color: rgba(255, 255, 255, 0.35);
  font-size: 3.333vw;
  flex-shrink: 0;
}

.bet-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2.22vw;
  padding-top: 2.22vw;
  border-top: 0.28vw solid rgba(255, 255, 255, 0.06);
}

.bet-sa {
  display: flex;
  align-items: center;
  gap: 1.67vw;
}

.pill {
  font-size: 3.06vw;
  font-weight: 700;
  padding: 0.83vw 2.22vw;
  border-radius: 5.555vw;
}

.yes-pill {
  background: rgba(76, 175, 130, 0.15);
  color: #4caf82;
}

.no-pill {
  background: rgba(224, 92, 92, 0.12);
  color: #e05c5c;
}

.b-amt {
  color: rgba(255, 255, 255, 0.5);
  font-size: 3.61vw;
}

.s-won {
  color: #4caf82;
  font-size: 3.61vw;
  font-weight: 700;
}

.s-lost {
  color: rgba(255, 255, 255, 0.3);
  font-size: 3.61vw;
}

.s-pend {
  color: rgba(246, 217, 170, 0.6);
  font-size: 3.61vw;
}

.hint {
  color: rgba(255, 255, 255, 0.2);
  font-size: 3.333vw;
  text-align: center;
  padding: 3.33vw 0;
}

/* SHEET */
.sheet-wrap {
  width: 100vw;
  height: 100dvh;
  background: #090909;
  overflow: hidden;
  border: 0.42vw solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
}

.sheet-won {
  position: relative;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100dvh;
  z-index: 2;
}

.sheet-overlay {
  position: absolute;
  bottom: 0;
  border-radius: 6.67vw 6.67vw 0 0;
  z-index: 3;
}

.sheet {
  background: #141414;
  border-radius: 5.555vw 5.555vw 0 0;
  padding: 0 0 7.777vw;
  border-top: 0.3vw solid rgba(255, 255, 255, 0.08);
  animation: slideInFromBottom 0.15s ease-out forwards;
}

@keyframes slideInFromBottom {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.sh-handle {
  width: 10vw;
  height: 1.11vw;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 0.6vw;
  margin: 3.33vw auto 0;
}

.sh-title {
  color: var(--primary-color);
  font-size: 4.444vw;
  font-weight: 700;
  padding: 4.444vw 5.555vw 0;
}

.sh-body {
  padding: 3.33vw 5.555vw 0;

  .sh-area {
    margin-bottom: 3.888vw;
  }
}

.sh-sec-t {
  color: rgba(255, 255, 255, 0.4);
  font-size: 3.06vw;
  font-weight: 600;
  letter-spacing: 0.0003em;
  text-transform: uppercase;
  margin-bottom: 2.22vw;
}

/* ── ANNOTATION LAYER ── */
.anno-wrap {
  display: flex;
  gap: 0;
  align-items: flex-start;
  position: relative;
}

.redline-panel {
  width: 55.555vw;
  flex-shrink: 0;
  position: relative;
}

.screen-label {
  font-size: 3.06vw;
  color: rgba(246, 217, 170, 0.4);
  font-weight: 600;
  letter-spacing: 0.0005em;
  text-transform: uppercase;
  margin-bottom: 2.777vw;
}
</style>



// WEBPACK FOOTER //
// src/pages/Predict/index.vue